import { useQuery } from '@apollo/client';
import { useEffect, useRef } from 'react';

import { getTeamSkillRows } from './team-detail-model';
import { GET_SETTINGS_TEAM_SKILLS, type SettingsTeamDetails } from '../../../../queries/skill-administration';

export function useTeamSkills(group: SettingsTeamDetails) {
  const hasCustomSkills = group.skillUuids.length > 0;
  const { data, loading, error, refetch } = useQuery(GET_SETTINGS_TEAM_SKILLS, {
    variables: { groupId: group.uuid },
    skip: !hasCustomSkills,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    context: { queryDeduplication: false },
    notifyOnNetworkStatusChange: true,
  });
  const previousSkillUuids = useRef(group.skillUuids);
  useEffect(() => {
    const added =
      previousSkillUuids.current.length > 0 &&
      group.skillUuids.some((uuid) => !previousSkillUuids.current.includes(uuid));
    previousSkillUuids.current = group.skillUuids;
    // Sharing confirms IDs before hydrated owner/details exist. Refresh only this independent section.
    if (added) void refetch().catch(() => undefined);
  }, [group.skillUuids, refetch]);
  const matchingGroup = data?.getSkillGroup.uuid === group.uuid;
  const failed = Boolean(error) || (!loading && hasCustomSkills && !matchingGroup);
  const skills = getTeamSkillRows(group, matchingGroup ? data.getSkillGroup.skills : []);
  return { skills, loading, failed, retry: () => void refetch().catch(() => undefined) };
}
